
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestzantaclawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestzantaclawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestzantaclawyers/privacy-policy"])
      });
    }
  